import { render, staticRenderFns } from "./VAB1.vue?vue&type=template&id=7d6d9d31&"
import script from "./VAB1.vue?vue&type=script&lang=js&"
export * from "./VAB1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports